"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
/* eslint-disable @typescript-eslint/no-explicit-any */
function memoize(func, resolver) {
  const memoized = function memoized(...args) {
    const key = resolver === null || resolver === void 0 ? void 0 : resolver(...args);
    const cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = func(...args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new Map();
  return memoized;
}